import RobotLoading from './RobotLoading';

export default RobotLoading;
